import * as React from 'react';
import { Container, Dropdown, DropdownButton, Nav, NavDropdown, Navbar } from 'react-bootstrap';
import { LANGUAGES } from "../common/constant";
import { useTranslation } from 'react-i18next';
import { LinkContainer } from 'react-router-bootstrap';
import { useLocation } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { Button, Modal } from 'react-bootstrap';
import "bootstrap-icons/font/bootstrap-icons.css";
import { DeleteSS } from '../common/sessionstorage';

interface IHeaderProps {
    // activelang: string,
    // setActiveLang: React.Dispatch<React.SetStateAction<string | undefined>>
}

const Header: React.FunctionComponent<IHeaderProps> = () => {
    const [cookies, setCookie] = useCookies(['lang']);
    const { i18n, t } = useTranslation();
    const location = useLocation();
    const [show, setShow] = React.useState(false);
    const [isCompact, setIsCompact] = React.useState(false);
    const handleLang = (lang_code: string) => {
        setShow(false);
        onSelectLang(lang_code);
    }
    const onSelectLang = React.useCallback((lang_code: any, doSaveCookies: boolean = true) => {
        i18n.changeLanguage(lang_code);
        // setActiveLang(lang_code);

        if (doSaveCookies) {
            // expires in 3 months 
            var expiryDate = new Date();
            expiryDate.setDate(expiryDate.getDate() + 90);
            setCookie('lang', lang_code, {
                expires: expiryDate
            });
        }
        DeleteSS("blog");

    }, [i18n, setCookie]);

    React.useEffect(() => {
        if (!cookies.lang) {
            setShow(true);
        }
        else {
            onSelectLang(cookies.lang, false);
        }

        const onScroll = () => {
            setIsCompact(window.scrollY > 36);
        };

        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });

        return () => {
            window.removeEventListener('scroll', onScroll);
        };
    }, [cookies.lang, onSelectLang]);

    const languageLabel = cookies.lang === "ta" ? "தமிழ்" : "English";
    const isServiceActive = location.pathname.startsWith('/dua') || location.pathname.startsWith('/prayertimes');

    return (
        <Navbar fixed="top" collapseOnSelect expand="lg" className={`top-nav-shell ${isCompact ? 'is-compact' : ''}`} >
            <Container fluid="lg" className="top-nav-container">
                <Navbar.Toggle aria-controls="navbarScroll" data-bs-target="#navbarScroll" />
                <LinkContainer to="/">
                    <Navbar.Brand className="brand-lockup" >
                        <img
                            alt="Masjid-e-Taqwa"
                            src="/logo512-white.png"
                            width="38"
                            height="38"
                            className="brand-logo"
                        />
                        <span className="brand-copy">
                            <strong className="brand-title">{t("title")}</strong>
                            <small className="brand-tagline">Knowledge, Duas, and Daily Guidance</small>
                        </span>
                    </Navbar.Brand>
                </LinkContainer>
                <Navbar.Collapse id="navbarScroll">
                    <Nav className="ms-auto navitemalignment mob-nav-custom top-nav-links">
                        <LinkContainer to="/">
                            <Nav.Link key="home">{t("home")}</Nav.Link>
                        </LinkContainer>
                        <NavDropdown title={t("service")} id="basic-nav-dropdown" className="mob-nav-custom top-nav-service" active={isServiceActive}>
                            <LinkContainer to="/dua">
                                <NavDropdown.Item key="dua">{t("dua")}</NavDropdown.Item>
                            </LinkContainer>
                            <LinkContainer to="/prayertimes">
                                <NavDropdown.Item key="prayertimes">{t("prayertimes")}</NavDropdown.Item>
                            </LinkContainer>
                        </NavDropdown>
                        <LinkContainer to="/socialservice">
                            <Nav.Link key="social">{t("social")}</Nav.Link>
                        </LinkContainer>
                        <LinkContainer to="/blog">
                            <Nav.Link key="blog">{t("blog")}</Nav.Link>
                        </LinkContainer>
                        <LinkContainer to="/aboutus">
                            <Nav.Link key="about">{t("about")}</Nav.Link>
                        </LinkContainer>
                    </Nav>
                </Navbar.Collapse>
                <DropdownButton
                    defaultValue={cookies.lang}
                    title={languageLabel}
                    id="dropdown-lang-menu-align-right"
                    onSelect={(e) => onSelectLang(e)}
                    variant="light"
                    className="lang-chip"
                >
                    {LANGUAGES.map(({ code, label }) => (
                        <Dropdown.Item key={code} eventKey={code}>
                            {label}
                        </Dropdown.Item>
                    ))}
                </DropdownButton>

            </Container>
            <Modal show={show} onHide={() => handleLang('en')}>
                <Modal.Header closeButton>
                    <Modal.Title>Language Selection <br /> மொழி தேர்வு</Modal.Title>
                </Modal.Header>
                <Modal.Body>Please select your language? <br /> தயவுசெய்து உங்கள் மொழியைத் தேர்ந்தெடுக்கவும்?</Modal.Body>
                <Modal.Footer >
                    <Button variant="secondary"  onClick={() => handleLang('en')}>
                        English
                    </Button>
                    <Button variant="primary" onClick={() => handleLang('ta')}>
                        தமிழ்
                    </Button>
                </Modal.Footer>
            </Modal>
        </Navbar >
    );
};

export default Header;


